import { render, staticRenderFns } from "./legalConsultingServices.vue?vue&type=template&id=f3ccf77c&scoped=true&"
import script from "./legalConsultingServices.vue?vue&type=script&lang=js&"
export * from "./legalConsultingServices.vue?vue&type=script&lang=js&"
import style0 from "./legalConsultingServices.vue?vue&type=style&index=0&id=f3ccf77c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ccf77c",
  null
  
)

export default component.exports